<template>
  <page-layout class="search_tnmt" ref="page">

  <display-container :section="511" :no-auto-link="true" class="title" ref="title">
    <template v-slot="{ component, row }">
      <div class="title_top">
        <p>{{component.getTitle(row)}}</p>
      </div>
    </template>
  </display-container>

    <div class="inner">

      <article class="results_lst">

        <!-- 서치박스 -->
        <div class="searchbox">
          <ul>
            <li>
              <p>Region</p>
              <el-checkbox-group v-model="searchQuery.region_idx" fill="#21ba45" size="large" @change="changeRegion">
                <el-checkbox v-for="(region, index) in getRegionOptions" :key="index" :label="region.idx" @click.native="handleChangeRegion($event, region.idx)">
                  {{ region.name }}
                </el-checkbox>
              </el-checkbox-group>
            </li>
            <li>
              <p>From</p>
              <label for="date"></label>
              <el-select
                  name="year"
                  id="year"
                  ref="year"
                  class="sel-year"
                  :value="getCurrentYear"
                  @change="changeYear"
                  :key="`year`">
                <el-option :value="y" v-for="y in getYearOptions" :key="`${y}`" >{{y}}</el-option>
              </el-select>
              &nbsp;
              <el-select
                  name="month"
                  id="month"
                  ref="month"
                  class="sel-month"
                  :value="getCurrentMonth"
                  @change="changeMonth"
                  :key="`month`">
                <el-option label="All Month" value="" />
                <el-option :value="m" v-for="m in getMonthOptions" :key="`${m}`" >{{Number(m)}}</el-option>
              </el-select>
              <!--<select name="year" ref="year" :value="getCurrentYear" @change="changeDate()" :key="`year`">
                <option :value="y" v-for="y in getYearOptions" :key="`${y}`">{{y}}년</option>
              </select>
              &nbsp;
              <select name="month" ref="month" :value="getCurrentMonth" @change="changeDate()" :key="`month`">
                <option :value="m" v-for="m in getMonthOptions" :key="`${m}`">{{Number(m)}}월</option>
              </select>-->
              <button class="reset m-hide" @click="reset">Reset</button>
            </li>
            <li>
              <p>Status</p>
              <el-checkbox-group v-model="searchQuery.period" fill="#21ba45" size="large" @change="changePeriod">
                <el-checkbox label="O" @click.native="handleChangePeriod($event, 'O')">
                  Ongoing
                </el-checkbox>
                <el-checkbox label="U" @click.native="handleChangePeriod($event, 'U')">
                  Upcoming
                </el-checkbox>
                <el-checkbox label="C"  @click.native="handleChangePeriod($event, 'C')">
                  Completed
                </el-checkbox>
              </el-checkbox-group>
              <button v-if="isMobile" class="reset rst-mo" @click="reset">Reset</button>
            </li>
          </ul>
        </div>

        <div class="info_wrap">
          <div class="info">
            <p>Tournament schedules are subject to change at the organizer’s discretion. <span>Please check the official channels for the latest schedule before booking flights or accommodations.</span></p>
          </div>
        </div>

        <div ref="lists">
          <!-- 리스트/토너먼트 -->
          <div class="list tnmt">
            <!-- basic view -->
            <div id="tournament_results" v-if="!isCompactView">
              <template v-for="(tournamentGroup, index) in queryTournamentsData">
                <div :key="tournamentGroup.date + index">
                  <div v-if="index === 0" class="title_wrap">
                    <h3>{{ getDateText(tournamentGroup.date) }}</h3>
                    <button v-on:click="toggleViewMode()" class="btn_view" v-show="!isCompactView">Compact View</button>
                    <button v-on:click="toggleViewMode()" class="btn_view" v-show="isCompactView">View by Month</button>
                  </div>
                  <div v-else class="title_wrap">
                    <h3 class="q-mt-xl" v-show="index > 0">{{ getDateText(tournamentGroup.date) }}</h3>
                  </div>
                  <div class="ad_list">
                    <display-container :section="512">
                      <a slot-scope="{ component, row }">
                        <img :src="component.getImage(row)">
                      </a>
                    </display-container>
                  </div>
                  <div v-for="(tournament, index) in tournamentGroup.row" :key="`${tournament.idx}`">
                    <div v-if="index > 0" v-show="index%4===0" class="ad_list">
                      <display-container :section="512">
                        <a slot-scope="{ component, row }">
                          <img :src="component.getImage(row)">
                        </a>
                      </display-container>
                    </div>
                    <div class="tnmt_ctnr" @click="goDetail(tournament)">
                      <div class="brand">
                        <div class="img"><img v-if="isFileExist(tournament.brand_logo_img)" :src="tournament.brand_logo_img.url"></div>
                      </div>
                      <div class="venue" v-if="isFileExist(tournament.poster_img)">
                        <div class="img"><img v-if="isFileExist(tournament.poster_img)" :src="tournament.poster_img.url"></div>
                      </div>
                      <div class="venue empty" v-else-if="isFileExist(tournament.brand_logo_img)">
                        <div class="img"><img :src="tournament.brand_logo_img.url"></div>
                      </div>
                      <div class="cont">
                        <h5>
                          <p>{{tournament.title}}</p>
                          <span v-if="tournament.period === 'O'" class="ongo">Now Ongoing<em class="shimmer"></em></span>
                        </h5>
                        <h6 class="loc"><span class="flag" v-if="tournament.flag_code"><img :src="`/statics/img/flags/${tournament.flag_code}.svg`"></span>{{ tournament.venue }}{{ tournament.country_name && `, ${tournament.country_name}` }}</h6>
                        <p class="date">{{ tournament.date }}</p>
                        <!--<p>Prize Pool : {{ tournament.prize_pool | comma }}</p>-->
                        <!--<p v-if="tournament.event_cnt > 0">Events : {{ tournament.event_cnt }} Event{{ tournament.event_cnt > 1 ? 's' : '' }}</p>
                        <p v-else>Events: TBD</p>-->
                      </div>
                      <div class="etc">
                        <span class="live" v-if="tournament.is_reporting"><img src="https://api.card-gorilla.com:8080/storage/corp/2/tips/28950/tips_lr.png"></span>
                        <span class="live" v-if="tournament.is_coverage"><img src="https://api.card-gorilla.com:8080/storage/corp/3/tips/31556/tips_nc.png"></span>
                        <span class="gpi" v-if="tournament.is_ranking"><img src="/en/statics/img/logo_gpi.png" /></span>
                      </div>
                      <!--<p v-if="tournament.period === 'O'" class="btn ongo">Now Ongoing</p>-->
                      <!--<p v-else class="btn">Read more</p>-->
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="queryTournamentsData.length === 0">
                <h3 v-if="isCompactView">After {{getDateText($route.query.date)}}</h3>
                <h3 v-else>{{ getDateText($route.query.date) }}</h3>
                <button v-on:click="toggleViewMode()" class="btn_view" v-show="!isCompactView">Compact View</button>
                <div class="no-results">
                  <p>No schedules that match the selected criteria.<br>Please select criteria again.</p>
                  <button class="reset" @click="reset">Reset</button>
                </div>
              </template>
            </div>

            <!-- compact view -->
            <div id="tournament_results" class="compact" v-else>
              <h3 v-if="isCompactView">After {{getDateText($route.query.date)}}</h3>
              <h3 v-else>{{ getDateText($route.query.date) }}</h3>
              <button v-on:click="toggleViewMode()" class="btn_view" v-show="isCompactView">View by Month</button>
              <ul class="th">
                <li><span>Venue</span></li>
                <li class="sort" @click="sort('date')"><span>Start<i :class="this.sortTournaments.key !== 'date' ? 'off' : this.sortTournaments.asc ? 'up' : 'down'"></i></span></li>
                <li><span>End</span></li>
                <li><span>Tournament</span></li>
              </ul>
              <div class="wrap" v-for="(tournament, index) in queryTournamentsDataCompact" :key="`${tournament.idx}`">
                <div v-if="index => 0" v-show="index%10===0" class="ad_list">
                  <display-container :section="512">
                    <a slot-scope="{ component, row }">
                      <img :src="component.getImage(row)">
                    </a>
                  </display-container>
                </div>
                <ul class="tr" @click="goDetail(tournament)">
                  <li class="brand">
                    <div class="img"><img v-if="isFileExist(tournament.brand_logo_img)" :src="tournament.brand_logo_img.url"></div>
                  </li>
                  <li class="venue" v-if="isFileExist(tournament.poster_img)">
                    <div class="img"><img v-if="isFileExist(tournament.poster_img)" :src="tournament.poster_img.url"></div>
                  </li>
                  <li class="venue empty" v-else-if="isFileExist(tournament.brand_logo_img)">
                    <div class="img"><img :src="tournament.brand_logo_img.url"></div>
                  </li>
                  <li>
                    <span class="m-hide flex"><span class="flag m-hide" v-if="tournament.flag_code"><img :src="`/statics/img/flags/${tournament.flag_code}.svg`"></span>{{ tournament.venue }}</span>
                    <span class="flag p-hide" v-if="tournament.flag_code"><img :src="`/statics/img/flags/${tournament.flag_code}.svg`"></span>
                  </li>
                  <li v-if="isMobile">{{ tournament.start_time.substring(5,10) }}</li>
                  <li v-else>{{ tournament.start_time }}</li>
                  <li v-if="isMobile">{{ tournament.end_time.substring(5,10) }}</li>
                  <li v-else>{{ tournament.end_time }}</li>
                  <li>
                    <p class="event" v-html="tournament.title"></p>
                    <span class="ongo" v-if="tournament.period === 'O'">Now Ongoing<em class="shimmer"></em></span>
                    <span class="live" v-if="tournament.is_reporting"><img src="https://api.card-gorilla.com:8080/storage/corp/2/tips/28950/tips_lr.png"></span>
                    <span class="live news" v-if="tournament.is_coverage"><img src="https://api.card-gorilla.com:8080/storage/corp/3/tips/31556/tips_nc.png"></span>
                  </li>
                </ul>
              </div>
              <ul v-if="queryTournamentsDataCompact.length === 0">
                <div class="no-results">
                  <p>No schedules that match the selected criteria.<br>Please select criteria again.</p>
                  <button class="reset" @click="reset">Reset</button>
                </div>
              </ul>
            </div>

          </div>
        </div>

        <!--        <div class="pager">-->
        <!--          <a class="prev" :class="{ off: !isPrevMonthPossible }" @click="goPrevMonth">지난달</a>-->
        <!--          <span><img src="/statics/img/bi_title.png"></span>-->
        <!--          <a class="next" :class="{ off: !isNextMonthPossible }" @click="goNextMonth">다음달</a>-->
        <!--        </div>-->

      </article>

    </div>

  </page-layout>
</template>

<script>
  import { Dialog, Loading, Select, Option, OptionGroup, Slider, Button, Checkbox, CheckboxButton, CheckboxGroup } from 'element-ui'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import commonComputed from 'src/_mixins/CommonComputed'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import VueScrollTo from "vue-scrollto";
  export default {
    name: "Tournaments",
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer,
      [Dialog.name]: Dialog,
      [Select.name]: Select,
      [Option.name]: Option,
      [OptionGroup.name]: OptionGroup,
      [Slider.name]: Slider,
      [Button.name]: Button,
      [CheckboxGroup.name]: CheckboxGroup,
      [CheckboxButton.name]: CheckboxButton,
      [Checkbox.name]: Checkbox,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | Schedule`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `A full calendar of live poker tournaments, featuring major stops, key dates, and buy-in details`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `Schedule | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `A full calendar of live poker tournaments, featuring major stops, key dates, and buy-in details`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        searchQuery: {},
        searchQueryOrigin: {
          region_idx: [1, 44, 45],
          // country_idx: '',
          brand_idx: '',
          date: moment().format('YMM'),
          period: ['O','U'],
          view_mode: ''
        },
        loading: {},
        sortTournaments: {
          key: 'date',
          asc: true
        },
        sortEvents: {
          key: 'date',
          asc: true
        },
        reA: /[^a-zA-Z-\s]/g,
        reN: /[^0-9]/g
      }
    },
    filters:{
      comma(val){
        const num = String(val).replace(/[^0-9]/g,'')
        const to = num.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        return String(val).replace(num, to);
      }
    },
    created() {
      this.searchQuery = this.cloneData(this.searchQueryOrigin)
      this.$store.dispatch('callRegionCountries')
      this.$store.dispatch('callBrands')
      this.$store.dispatch('callDatePeriod')
    },
    activated () {
      this.$nextTick(() => {
        this.getRouteQuery()
        this.$store.dispatch('callTournaments')
      })
    },
    beforeRouteUpdate (to, from, next) {
      if (JSON.stringify(to.query) !== JSON.stringify(from.query)) {
        next()
        this.$nextTick(() => {
          this.getRouteQuery()
          let toQuery = this.makeKey(this.cloneData(to.query))
          let fromQuery = this.makeKey(this.cloneData(from.query))
          if (JSON.stringify(toQuery) !== JSON.stringify(fromQuery)) {
            this.$store.dispatch('callTournaments')
          }
        })
      } else {
        next(false)
      }
    },
    beforeRouteLeave(to, from, next) {
      this.setSearchQueryFromRouteQuery()
      next()
    },
    watch: {
      'getDatePeriod' () {
        if (!this.isRightDatePeriod()) {
          this.searchQuery.date = moment().format('YMM')
          this.setRouteQueryFromSearchQuery()
        }
      }
    },
    computed: {
      ...commonComputed,
      ...mapGetters([
        'getRegionCountries',
        'getBrands',
        'getTournaments',
        'getEvents',
        'getDatePeriod',
        'makeKey'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      getRegionOptions () {
        return this.getRegionCountries.filter(row => row.idx_p === 0)
      },
      getCountryOptions () {
        return this.getRegionCountries.filter(row => row.idx_p > 0)
      },
      getCurrentYear () {
        return this.searchQuery.date ? this.searchQuery.date.toString().substring(0, 4) : moment().format('Y')
      },
      getCurrentMonth () {
        return this.searchQuery.date ? this.searchQuery.date.toString().substring(4, 6) : moment().format('MM')
      },
      getYearOptions () {
        const dates = this.getDatePeriod
        const years = []
        if (Object.keys(dates).length > 0) {
          const start_year = moment(dates.start_date).format('Y')
          const end_year = moment(dates.end_date).format('Y')
          for (let y = end_year; y >= start_year; y--) years.push(y)
        }
        return years
      },
      getMonthOptions () {
        const dates = this.getDatePeriod
        if (Object.keys(dates).length < 1) return ['01']
        const months = []
        if (Object.keys(dates).length > 0) {
          const start_date = moment(dates.start_date)
          const end_date = moment(dates.end_date)
          for (let d = end_date; d > start_date; d = d.subtract(1, 'months')) {
            if (d.format('Y') === this.getCurrentYear) {
              months.push(d.format('MM'))
            }
          }
        }
        return months
      },
      isPrevMonthPossible () {
        return Number(this.searchQuery.date) > Number(moment(this.getDatePeriod.start_date).format('YMM'))
      },
      isNextMonthPossible () {
        return Number(this.searchQuery.date) < Number(moment(this.getDatePeriod.end_date).format('YMM'))
      },
      isCompactView () {
        return this.searchQuery.view_mode === 'compact'
      },
      queryTournamentsData () {
        if (!this.searchQuery.date) return []
        if (this.getTournaments.data.length === 0) return []

        const ownData = this.cloneData(this.queryTournamentsOwnData)
        const filterPeriods = this.searchQuery.period || []
        const currentDate = this.getNumberTime(moment())
        let data = null

        if (this.searchQuery.date.length === 4) {
          data = Array.from({ length: 12 }, (_, i) => ({ date: Number(this.getCurrentYear + String(i+1).padStart(2, '0')), row: {} }))
        } else {
          const startTime = moment(this.searchQuery.date)
          const allEndTimes = ownData.map(obj => moment(obj.end_time))
          let endTime = moment.max(allEndTimes)
          endTime = endTime.add(1, 'months')
          let currentTime = startTime
          data = Array.from({ length: endTime.diff(startTime, 'months') }, () => {
            const rtn = { date: this.getNumberTimeMonth(currentTime.format('Y-MM-DD')), row: {} }
            currentTime = currentTime.add(1, 'months')
            return rtn
          })
        }

        return data.map((d) => {
          d.row = ownData.filter(row => {
            const rowStartMonth = this.getNumberTimeMonth(row.start_time)
            const rowEndMonth = this.getNumberTimeMonth(row.end_time)
            const rowStartDate = this.getNumberTime(row.start_time)
            const rowEndDate = this.getNumberTime(row.end_time)

            const isRightMonth = rowStartMonth <= d.date && d.date <= rowEndMonth
            const isOngoing = isRightMonth && rowStartDate <= currentDate && currentDate <= rowEndDate
            const isUpcoming = isRightMonth && rowStartDate > currentDate && rowEndDate > currentDate
            const isCompleted = isRightMonth && rowEndDate < currentDate

            let includeRow = false

            if (filterPeriods.includes('O') && isOngoing) { includeRow = true; row.period = 'O' }
            if (filterPeriods.includes('U') && isUpcoming) { includeRow = true; row.period = 'U' }
            if (filterPeriods.includes('C') && isCompleted) { includeRow = true; row.period = 'C' }

            return includeRow
          })
          return d
        }).filter(row => row.row.length > 0)
      },
      queryTournamentsDataCompact () {
        const data = this.cloneData(this.queryTournamentsOwnData)
        const filterPeriods = this.searchQuery.period || []
        const currentDate = this.getNumberTime(moment())
        return data.filter(row => {
          const rowStartDate = this.getNumberTime(row.start_time)
          const rowEndDate = this.getNumberTime(row.end_time)

          const isOngoing = rowStartDate <= currentDate && currentDate <= rowEndDate
          const isUpcoming = rowStartDate > currentDate && rowEndDate > currentDate
          const isCompleted = rowEndDate < currentDate

          let includeRow = false

          if (filterPeriods.includes('O') && isOngoing) { includeRow = true; row.period = 'O' }
          if (filterPeriods.includes('U') && isUpcoming) { includeRow = true; row.period = 'U' }
          if (filterPeriods.includes('C') && isCompleted) { includeRow = true; row.period = 'C' }

          return includeRow
        })
      },
      queryTournamentsOwnData () {
        if (this.getTournaments.data.length === 0) return []
        return this.sortTournaments.asc
            ? this.getTournaments.data.sort((a, b) => this.sortAlphaNum(a[this.sortTournaments.key], b[this.sortTournaments.key]))
            : this.getTournaments.data.sort((a, b) => this.sortAlphaNum(b[this.sortTournaments.key], a[this.sortTournaments.key]))
      },
      queryEventsData () {
        return this.sortEvents.asc
            ? this.getEvents.data.sort((a, b) => this.sortAlphaNum(a[this.sortEvents.key], b[this.sortEvents.key]))
            : this.getEvents.data.sort((a, b) => this.sortAlphaNum(b[this.sortEvents.key], a[this.sortEvents.key]))
      }
    },
    methods: {
      ...CommonMethods,
      getNumberTimeMonth (strDate) {
        return Number(moment(strDate).format('YMM'))
      },
      getNumberTime (strDate) {
        return Number(moment(strDate).format('YMMDD'))
      },
      sortAlphaNum(a, b) {
        const aA = a.toString().replace(this.reA, '');
        const bA = b.toString().replace(this.reA, '');
        if (aA === bA) {
          const aN = parseInt(a.toString().replace(this.reN, ''), 10);
          const bN = parseInt(b.toString().replace(this.reN, ''), 10);
          return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
          return aA > bA ? 1 : -1;
        }
      },
      getRouteQuery () {
        this.searchQuery = Object.keys(this.searchQuery).length > 0 ? this.cloneData(this.searchQuery) : this.cloneData(this.searchQueryOrigin)
        let query = this.cloneData(this.$route.query)
        if (query) {
          Object.keys(this.searchQuery).map(key => {
            if (query[key]) {
              if (key === 'date') {
                let date
                let raw = query[key]
                if (raw.length === 4) {
                  date = moment(raw, 'YYYY', true)
                } else {
                  date = moment(raw.length === 6 ? raw + '01' : raw)
                }
                query[key] = raw.length === 4 ? date.format('Y') : date.format('YMM')
              }
              if (key === 'region_idx') {
                this.searchQuery[key] = query[key].split(',').map(row => Number(row))
              } else if (key.substr(-3) === 'idx') {
                this.searchQuery[key] = Number(query[key])
              } else if (key === 'view_mode' && query[key] === 'compact') {
                this.searchQuery[key] = query[key]
              } else if (key === 'period') {
                this.searchQuery[key] = query[key].split(',')
              } else {
                this.searchQuery[key] = query[key]
              }
            }
          })
          this.setRouteQueryFromSearchQuery()
        }
      },
      setRouteQueryFromSearchQuery () {
        const query = this.cloneData(this.searchQuery)
        query['period'] = query['period'].join(',')
        query['region_idx'] = query['region_idx'].join(',')
        this.$router.replace({ path: this.$route.path, query: query })
      },
      setSearchQueryFromRouteQuery () {
        let query = this.cloneData(this.$route.query)
        Object.keys(this.searchQuery).map(key => {
          if (query[key]) {
            if (key === 'region_idx') {
              this.searchQuery[key] = query[key].split(',').map(row => Number(row))
            } else if (key === 'period') {
              this.searchQuery[key] = query[key].split(',')
            } else if (key === 'view_mode') {
              this.searchQuery[key] = query[key]
            } else {
              this.searchQuery[key] = query[key]
            }
          }
        })
      },
      isRightDatePeriod (date = this.searchQuery.date) {
        if (date.length === 4) {
          date = Number(date)
          const start = Number(this.getDatePeriod.start_date.substring(0, 4))
          const end = Number(this.getDatePeriod.end_date.substring(0, 4))
          return date >= start && date <= end
        } else {
          return moment(date).isBetween(this.getDatePeriod.start_date, this.getDatePeriod.end_date)
        }
      },
      changeYear (year) {
        year = year.toString()
        if (year !== this.$refs.year.value) {
          if (this.searchQuery.date.length === 4) {
            this.searchQuery.date = moment(year + '0101').format('Y')
          } else if (this.isRightDatePeriod(year+this.$refs.month.value)) {
            this.searchQuery.date = moment(year+this.$refs.month.value+'01').format('YMM')
          } else {
            const dates = this.getDatePeriod
            const start_year = moment(dates.start_date).format('Y')
            const start_month = moment(dates.start_date).format('MM')
            const end_year = moment(dates.end_date).format('Y')
            const end_month = moment(dates.end_date).format('MM')
            if (year === start_year) {
              this.searchQuery.date = moment(year+start_month+'01').format('YMM')
            } else if (year === end_year) {
              this.searchQuery.date = moment(year+end_month+'01').format('YMM')
            }
          }
          this.setRouteQueryFromSearchQuery()
        }
      },
      changeMonth (month) {
        if (month) {
          this.searchQuery.date = moment(this.$refs.year.value + month + '01').format('YMM')
        } else {
          this.searchQuery.date = moment(this.$refs.year.value).format('Y')
        }
        this.setRouteQueryFromSearchQuery()
      },
      getDateText (date = '') {
        if (date.toString().indexOf('-') > -1) {
          date = date.replace(/\-/g, '').substring(0, 6)
        }
        if (date.length === 4) date = date + this.getMonthOptions[this.getMonthOptions.length-1]
        const y = date ? moment(date + '15').format('YYYY') : ''
        const m = date ? moment(date + '15').format('MMMM') : ''
        return `${m} ${y}`
      },
      matchSortValue (val) {
        return Number(val.match(/(\d+)/g)[0])
      },
      reset () {
        this.regionCountry = ''
        this.searchQuery = this.cloneData(this.searchQueryOrigin)
        this.setRouteQueryFromSearchQuery()
      },
      sort (key) {
        const obj = this.sortTournaments
        obj.key === key ? obj.asc = !obj.asc : obj.key = key
      },
      goDetail (row) {
        this.$router.push({path: `/tournament/${row.idx}`})
      },
      goPrevMonth () {
        if (this.isPrevMonthPossible) {
          this.searchQuery.date = moment(this.searchQuery.date+'15').subtract(1,'months').format('YMM')
          this.beforeGoMove()
        }
      },
      goNextMonth () {
        if (this.isNextMonthPossible) {
          this.searchQuery.date = moment(this.searchQuery.date+'15').add(1,'months').format('YMM')
          this.beforeGoMove()
        }
      },
      beforeGoMove () {
        if (this.isMobile) {
          this.setRouteQueryFromSearchQuery()

          const el = this.$refs.title.$el
          const duration = 0
          VueScrollTo.scrollTo(el, duration, {offset: 470, onDone:() => {
              this.$store.dispatch('callTournaments')
            }})
        } else {
          this.setRouteQueryFromSearchQuery()
        }
      },
      toggleViewMode () {
        this.searchQuery.view_mode = this.searchQuery.view_mode === '' ? 'compact' : ''
        this.setRouteQueryFromSearchQuery()
      },
      changePeriod (val) {
        this.setRouteQueryFromSearchQuery()
      },
      handleChangePeriod (e, val) {
        if (this.searchQuery.period.length < 2 && this.searchQuery.period.includes(val)) {
          e.preventDefault()
          e.stopPropagation()
        }
      },
      changeRegion (checked) {
        // console.log(checked, this.searchQuery.region_idx)
        this.setRouteQueryFromSearchQuery()
      },
      handleChangeRegion (e, val) {
        if (this.searchQuery.region_idx.length < 2 && this.searchQuery.region_idx.includes(val)) {
          e.preventDefault()
          e.stopPropagation()
        }
      }
    }
  }
</script>

<style scoped>
  .search_tnmt {
    position: relative;
    top: -40px;
  }
  .display-container.title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 10px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
  .searchbox {
    background: ;
  }
  .searchbox ul {
    border-bottom: 1px solid #aaa;
  }
  .searchbox li {
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.02em;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    height: 80px;
  }
  .searchbox li p {
    display: inline-block;
    text-align: center;
    padding: 0 15px 0 45px;
    font-size: 15px;
    font-weight: 700;
    color: #222;
    letter-spacing: -0.03em;
  }
  .searchbox li:first-child p {
    padding-left: 0;
  }
  .searchbox .reset {
    display: inline-block;
    padding: 8px 10px 8px 25px;
    font-size: 15px;
    font-weight: 500;
    color: #333;
    cursor: pointer;
    position: absolute;
    right: 20px;
  }
  .searchbox .reset:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 19px;
    background-image: url(/statics/img/icon_reset.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: 50% center;
    filter: brightness(0);
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0,-50%);
  }
  .el-select {
    width: 100px;
  }
  .el-select.sel-region {
    width: 180px;
  }
  .el-select.sel-brand {
    width: 300px;
  }
  /deep/ .el-input__inner::-webkit-input-placeholder {
    color: #000;
  }
  /deep/ .el-input__inner:-moz-placeholder {
    color: #000;
  }
  /deep/ .el-input__inner:-ms-input-placeholder {
    color: #000;
  }
  /deep/ .el-input__inner {
    border: 0;
    font-size: 16px;
    font-weight: 600;
    color: #000;
    letter-spacing: -0.02em;
    border-radius: 4px;
  }
  /deep/ .el-icon-arrow-up:before {
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(/statics/img/a_arrow_v.png) no-repeat;
    background-size: contain;
    transform: rotate(180deg) translate(0,-90%);
  }
  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #008c03;
  }
  /deep/ .el-select .el-input__inner:focus {
    border-color: #008c03;
  }
  .el-select-dropdown__item {
    font-size: 15px;
    font-weight: 500;
  }
  .el-select-dropdown__item.selected {
    color: #008c03;
  }
  .el-select-dropdown__item.hover {
    background-color: #f5f8f5;
  }
  /deep/ .el-checkbox {
    margin-right: 15px;
  }
  /deep/ .el-checkbox:last-child {
    margin-right: 0;
  }
  /deep/ .el-checkbox__label {
    font-size: 15px;
    font-weight: 500;
    color: #888;
    line-height: 1.4em;
    padding-left: 8px;
  }
  /deep/ .el-checkbox__inner {
    width: 18px;
    height: 18px;
    border: 1px solid #ccc;
    border-radius: 3px;
  }
  /deep/ .el-checkbox__inner:after {
    height: 8px;
    width: 4px;
    left: 5px;
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
  }
  /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #008c03;
  }
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #008c03;
    border-color: #008c03;
  }
  /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #008c03;
  }
  .searchbox li .option {
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    color: #666;
    background: #eee;
    padding: 14px 28px;
    margin: 0 3px;
    cursor: pointer;
    transition: .15s;
  }
  .searchbox li .option.on {
    font-weight: 800;
    color: #000;
    background: #00ff64;
  }
  .searchbox li .option:hover {
    background: #ddd;
  }
  .searchbox li .option.on:hover {
    background: #00ff64;
  }
  .searchbox li .btn_sch {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    background: #000;
    padding: 16px 100px;
    border-radius: 5px;
    cursor: pointer;
    transition: .15s;
  }
  .searchbox li .btn_sch:hover {
    color: #00ff64;
  }
  .searchbox li .btn_reset {
    font-weight: 800;
    padding: 16px 30px;
    border: 1px solid #aaa;
    border-radius: 5px;
    margin-left: 10px;
    cursor: pointer;
    transition: .15s;
  }
  .searchbox li .btn_reset:hover {
    background: #eee;
  }
  .searchbox li .for_mo p {
    line-height: 53px;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-size: inherit;
    border: 1px solid #aaa;
    padding: 14px 70px 14px 20px;
    background: url(/statics/img/a_arrow_v.png) no-repeat;
    background-size: 16px 14px;
    background-position: right 18px top 50%;
    cursor: pointer;
    transition: .15s;
  }
  select:hover {
    border: 1px solid #666;
  }
  select::-ms-expand {
    display: none;
  }
  select option {
    padding: 10px;
  }
  .info_wrap {
    margin: 20px 0 0 0;
  }
  .info_wrap .info {
    background: rgba(0,0,0,0.035);
    padding: 18px 22px;
    border-radius: 8px;
  }
  .info_wrap .info p {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    letter-spacing: 0em;
    line-height: 1.2em;
  }
  .info_wrap .info p:before {
    content: "!";
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: 1px solid #008c03;
    border-radius: 100%;
    font-size: 12px;
    font-weight: 600;
    color: #008c03;
    margin-right: 6px;
  }
  .list {
    margin-top: 60px;
  }
  .list h3 {
    font-size: 27px;
    font-weight: 600;
    letter-spacing: -0.015em;
    margin-bottom: 15px;
    display: inline-block;
    letter-spacing: -0.03em;
  }
  .list .btn_view {
    font-size: 13px;
    font-weight: 600;
    color: #000;
    letter-spacing: -0.02em;
    padding: 8px 15px 8px 36px;
    margin: 3px 0 0 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
  }
  .list .btn_view:hover {
    border: 1px solid #999;
  }
  .list .btn_view:after {
    content: "↔";
    font-size: 17px;
    font-weight: 900;
    color: #008c03;
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translate(0,-50%);
  }
  .list ul {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70px;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: -0.01em;
    transition: .15s;
    border: 1px solid transparent;
    position: relative;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 5px;
  }
  .list ul.th {
    background: #103700;
    font-weight: 500;
    color: #fff;
    height: 60px;
    padding: 0;
    line-height: 1.0em;
    border-radius: 8px;
    justify-content: space-between;
  }
  .list ul.th li.sort span {
    cursor: pointer;
  }
  .list ul.th li span {
    position: relative;
    display: inline-block;
  }
  .list ul.th li:nth-child(1) {
    width: 33.5%;
  }
  .list ul.th li:nth-child(2) {
    width: 13.5%;
  }
  .list ul.th li:nth-child(3) {
    width: 13.5%;
    text-align: center;
    padding: 0;
  }
  .list ul.th li:nth-child(4) {
    width: 39.5%;
  }
  .list ul.th li:last-child span {
    max-width: min-content;
  }
  .list ul.th li span i {
    position: absolute;
    top: 50%;
    right: -25px;
    transform: translate(0, -50%);
  }
  .list ul.th li .off:before {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    border-bottom: 6px solid rgba(0,255,100,0.3);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    transform: translate(50%, 20%);
  }
  .list ul.th li .off:after {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 6px solid rgba(0,255,100,0.3);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    transform: translate(-50%, 160%);
  }
  .list ul.th li .up:after {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    border-bottom: 6px solid rgba(0,255,100,1.0);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    transform: translate(-50%, 100%);
  }
  .list ul.th li .down:after {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 6px solid rgba(0,255,100,1.0);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    transform: translate(-50%, 100%);
  }
  .list ul.tr {
    cursor: pointer;
  }
  .list ul.tr:hover {
    color: #379339;
    border: 1px solid #379339;
    box-shadow: 0 0 6px rgba(0,0,0,0.15);
    z-index: 1;
  }
  .list li {
    text-align: center;
    line-height: 1.1em;
    overflow: hidden;
  }
  .list li span {
    position: relative;
    display: inline-block;
  }
  .list li span.flex {
    display: flex;
    align-items: center;
  }
  .list li span img {
    max-width: 100%;
    max-height: 100%;
  }
  .list li p.event {
    display: inline;
    font-family: 'Montserrat';
    font-size: 17px;
    padding-right: 10px;
  }
  .list li .flag {
    width: 20px;
    height: 15px;
    margin-right: 10px
  }
  .list li .flag:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0,0,0,0.15);
    z-index: 1;
  }
  .list li .ongo {
    position: relative;
    overflow: hidden;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    line-height: 1.0em;
    background: #dd0000;
    display: inline-block;
    padding: 3px 5px;
    border-radius: 3px;
  }
  .shimmer {
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: skewX(-25deg);
    animation: light-swipe 1.8s infinite ease-in-out;
  }
  @keyframes light-swipe {
    0% {
      left: -200%;
    }
    100% {
      left: 200%;
    }
  }
  .list li .live {
    height: 18px;
    margin-left: 15px;
  }
  .list li .live.news {
    margin-left: 8px;
  }
  .list li:nth-child(1) {
    width: 80px;
  }
  .list li:nth-child(2) {
    width: 160px;
  }
  .list li:nth-child(3) {
    width: 15%;
    text-align: left;
    padding-left: 40px;
  }
  .list li:nth-child(4) {
    width: 13.5%;
  }
  .list li:nth-child(5) {
    width: 13.5%;
  }
  .list li:nth-child(6) {
    width: 39%;
    font-weight: 700;
    text-align: left;
    padding: 0 20px 0 40px;
  }
  .list li.brand {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 100%;
    background: #000;
  }
  .list li.brand .img {
    width: 46px;
    height: 46px;
  }
  .list li.brand .img img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .list li.venue {
    background: #333;
  }
  .list li.venue .img img {
    width: 100%;
    height: 100%;
  }
  .list li.venue.empty .img img {
    filter: blur(20px) opacity(0.45);
  }

  .list.event li:nth-child(1) {
    width: 7%;
  }
  .list.event li:nth-child(2) {
    width: 7%;
  }
  .list.event li:nth-child(3) {
    width: 11%;
  }
  .list.event li:nth-child(4) {
    width: 25%;
  }
  .list.event li:nth-child(5) {
    width: 9%;
  }
  .list.event li:nth-child(6) {
    width: 15%;
  }
  .list.event li:nth-child(7) {
    width: 8%;
  }
  .list.event li:nth-child(8) {
    width: 7%;
  }
  .list.event li:nth-child(9) {
    width: 11%;
  }
  .list .ad_list /deep/ a {
    display: inline-block;
    width: 100%;
    padding: 34px 0;
    text-align: center;
    background: #fff;
    margin-bottom: 10px;
    border-radius: 8px;
  }
  .list .ad_list /deep/ a img {
    width: 728px !important;
    height: 90px !important;
  }
  .list .compact .ad_list /deep/ a {
    padding: 20px 0;
    background: none;
    margin-bottom: 0;
  }
  .list .tnmt_ctnr {
    position: relative;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 10px;
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0);
    transition: .15s;
    display: flex;
    border-radius: 8px;
    overflow: hidden;
  }
  .list .tnmt_ctnr .brand {
    position: relative;
    left: 0;
    display: inline-block;
  }
  .list .tnmt_ctnr .brand .img {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 100%;
    background: #000;
  }
  .list .tnmt_ctnr .brand .img:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 5px;
    z-index: 1;
  }
  .list .tnmt_ctnr .brand .img img {
    width: 110px;
    height: 110px;
    max-width: 100%;
    border-radius: 5px;
  }
  .list .tnmt_ctnr .venue .img {
    position: relative;
    width: 280px;
    height: 100%;
    overflow: hidden;
  }
  .list .tnmt_ctnr .venue .img img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .list .tnmt_ctnr .venue.empty .img {
    background: #333;
  }
  .list .tnmt_ctnr .venue.empty .img img {
    filter: blur(20px) opacity(0.45);
  }
  .list .tnmt_ctnr .cont {
    width: 100%;
    padding: 30px 0 30px 40px;
    align-self: center;
  }
  .list .tnmt_ctnr .cont h5 {
    font-family: 'montserrat';
    width: 85%;
  }
  .list .tnmt_ctnr .cont h5 p {
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.0em;
    display: inline;
    margin-right: 10px;
  }
  .list .tnmt_ctnr .cont h5 .ongo {
    position: relative;
    overflow: hidden;
    display: inline-block;
    padding: 5px 8px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0em;
    line-height: 1.0em;
    background: #d00;
    border-radius: 5px;
    transition: .15s;
  }
  .list .tnmt_ctnr .cont .loc {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    padding: 7px 0 15px 0;
    letter-spacing: -0.01em;
  }
  .list .tnmt_ctnr .cont .flag {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 15px;
    margin-right: 10px;
  }
  .list .tnmt_ctnr .cont .flag:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0,0,0,0.15);
    z-index: 1;
  }
  .list .tnmt_ctnr .cont p.date {
    font-size: 20px;
    font-weight: 500;
    color: #888;
    letter-spacing: -0.03em;
    line-height: 1.0em;
    padding: 0;
  }
  .list .tnmt_ctnr .cont p.date:before {
    display: none;
  }
  .list .tnmt_ctnr .etc {
    display: inline-block;
    width: 25%;
    text-align: right;
    position: absolute;
    bottom: 30px;
    right: 30px;
  }
  .list .tnmt_ctnr .etc span {
    display: inline-block;
    height: 25px;
    margin-right: 20px;
  }
  .list .tnmt_ctnr .etc span:last-child {
    margin-right: 0;
  }
  .list .tnmt_ctnr .etc span img {
    max-width: 100%;
    max-height: 100%;
  }
  .list .tnmt_ctnr .etc span.flag {
    position: relative;
    width: 40px;
  }
  .list .tnmt_ctnr .etc span.flag:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0,0,0,0.15);
    z-index: 1;
  }
  .list .tnmt_ctnr .btn {
    position: absolute;
    right: 30px;
    bottom: 30px;
    display: inline-block;
    text-align: center;
    width: 200px;
    padding: 16px 20px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    background: #000;
    border-radius: 5px;
    transition: .15s;
  }
  .list .tnmt_ctnr .btn:after {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border: solid #fff;
    border-width: 1px 1px 0 0;
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translate(0,-50%) rotate(45deg);
  }
  .list .tnmt_ctnr .btn.ongo {
    color: #fff;
    background: #dd0000;
  }
  .list .tnmt_ctnr:hover {
    background: #fff;
    border: 1px solid #379339;
  }
  .list .tnmt_ctnr:hover .btn {
    color: #fff;
    background: #00c74e;
  }
  .list .tnmt_ctnr:hover .btn.ongo {
    color: #fff;
    background: #ff0000;
  }
  .list .no-results {
    text-align: center;
    padding: 100px 0;
  }
  .list .no-results p {
    font-size: 18px;
    font-weight: 400;
    color: #777;
    letter-spacing: 0.0em;
  }
  .list .no-results .reset {
    display: inline-block;
    padding: 10px 20px 10px 45px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    position: relative;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-top: 30px;
  }
  .list .no-results .reset:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 19px;
    background-image: url(/statics/img/icon_reset.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: 50% center;
    filter: brightness(0);
    position: absolute;
    left: 18px;
  }
  .pager {
    margin-top: 40px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }
  .pager a {
    cursor: pointer;
    line-height: 2.0em;
    transition: .15s;
  }
  .pager a:hover {
    color: #379339;
  }
  .pager a.prev:before {
    content: "";
    display: inline-block;
    width: 14px;
    height: 16px;
    background: url(/statics/img/a_arrow.png) no-repeat;
    background-size: contain;
    margin-right: 18px;
    margin-top: 10px;
    transform: rotate(180deg);
  }
  .pager a.next:after {
    content: "";
    display: inline-block;
    width: 14px;
    height: 16px;
    background: url(/statics/img/a_arrow.png) no-repeat;
    background-size: contain;
    margin-left: 18px;
    margin-top: 10px;
  }
  .pager span {
    margin: 0 40px;
  }
  .pager a.off {
    color: #bbb;
    cursor: default;
  }
  .pager a.off:before,
  .pager a.off:after {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    opacity: 0.5;
  }
  .p-hide {
    display: none !important;
  }
  /deep/ .el-loading-spinner .path { stroke: #000; }
  /* on wallpaper */
  #q-app.wallpaper .tnmt_ctnr {
    background: #f5f5f5;
  }
  #q-app.wallpaper .list /deep/ .ad_list a {
    background: #f5f5f5;
    border-radius: 8px;
  }
  #q-app.wallpaper .list .compact /deep/ .ad_list a {
    background: none;
  }
  #q-app.wallpaper .compact .tr {
    background: #f5f5f5;
  }
</style>
